import React, { useEffect, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  FlagIcon,
  CheckmarkCircleIcon,
  DismissCircleIcon,
  MeatBallsMenuIcon,
} from "../../../../../modules/default-svg";
import { useState } from "react";
import HoverCard from "../../../../hoverCard/HoverCard";
import {
  getAccountCurrency,
  utcToLocalDateString,
} from "../../../../../utils/systemSettings";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const AllocatedRsrcRow = (props) => {
  const {
    parentType,
    sortingCriteria,
    data,
    sortResourcesRequest,
    sortClientResourcesRequest,
    portfolioId,
    projectId,
    programId,
    clientId,
    menu,
    updateFlag,
    handleModal,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [sortedData, setSortedData] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [setting] = useState(settings);
  const [popoverOpen, setPopoverOpen] = useState(null);
  const popoverRef = useRef(null);

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      const data = {
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      };
      if (parentType === "Client") {
        data.id = clientId;
        data.parent = "Client";
        // sortClientResourcesRequest({id: clientId, page:1, size:10, orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`});
      }
      if (parentType === "Project") {
        data.id = projectId;
        data.parent = "Project";
      }
      if (parentType === "Program") {
        data.id = programId;
        data.parent = "Program";
      }
      if (parentType === "Portfolio") {
        data.id = portfolioId;
        data.parent = "Portfolio";
      }

      sortResourcesRequest(data);
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      setSortedData(data);
    }
  }, [data]);

  const handlePopoverOpen = (itemId) => {
    if (popoverOpen === itemId) {
      // If the clicked item's popover is already open, close it
      setPopoverOpen(null);
    } else {
      // Otherwise, open the popover for the clicked item
      setPopoverOpen(itemId);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        handlePopoverOpen(null); // Close the popover
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverRef, handlePopoverOpen]);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({ id: id, isFlag: true });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({ id: id, isFlag: false });
  };

  useEffect(() => {
    const sortedArray = sortDataByFlagged(data, flagged);
    setSortedData(sortedArray);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const styles = useStyles();
  return sortedData.map((item) => (
    <TableRow key={item.id}>
      <TableCell role="gridcell">
        <div className="d-flex justify-content-between">
          <TableCellLayout
            media={
              <>
                <Tooltip
                  positioning="before"
                  content={{
                    children: flagged.includes(item.id) ? "Unflag" : "Flag",
                    className: styles.tooltip,
                  }}
                  relationship="label"
                  withArrow
                >
                  <span
                    className={`flag ${
                      flagged.includes(item.id) ? "flagActive" : ""
                    }`}
                    onClick={() =>
                      flagged.includes(item.id)
                        ? removeFlag(item)
                        : addFlag(item.id)
                    }
                  >
                    <FlagIcon />
                  </span>
                </Tooltip>
                <div className="d-flex justify-content-between gap-2">
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.fullName}
                        image={{ src: item.profilePictureUrl }}
                      />
                    }
                    AvatarId={item.id}
                    AvatarName={item.fullName}
                    AvatarDesignation={item.title}
                    AvatarImage={item.profilePictureUrl}
                    AvatarEmail={item.email}
                    AvatarPhone={item.phoneNumber}
                    AvatarIsExternal={item.isExternal}
                  />
                  <span className="text-sm-400 mt-1">{item.fullName}</span>
                </div>
              </>
            }
          ></TableCellLayout>
          <div className="flag">
            <Popover
              open={popoverOpen === item.id}
              onOpenChange={(isOpen) => isOpen && handlePopoverOpen(item.id)}
              positioning="below-start"
            >
              <PopoverTrigger disableButtonEnhancement>
                <TableCellLayout
                  media={<MeatBallsMenuIcon />}
                  onClick={() => {
                    handleModal(item);
                    handlePopoverOpen(item.id);
                  }}
                />
              </PopoverTrigger>
              <PopoverSurface tabIndex={-1} className="listingPopoverWrapper">
                {menu}
              </PopoverSurface>
            </Popover>
          </div>
        </div>
      </TableCell>
      <TableCell>{item.email}</TableCell>
      <TableCell>{item.role}</TableCell>
      <TableCell>{item.title}</TableCell>
      <TableCell>
        {item.hourlyRate
          ? `${getAccountCurrency(setting)} ${item.hourlyRate}`
          : ""}
      </TableCell>
      <TableCell>{item.maxHours ? `${item.maxHours} h` : ""}</TableCell>
      <TableCell>
        {item.operationalCapacity ? `${item.operationalCapacity} %` : ""}
      </TableCell>
      <TableCell>
        {item.projectCapacity ? `${item.projectCapacity} %` : ""}
      </TableCell>
      <TableCell>
        {item.isExternal ? <CheckmarkCircleIcon /> : <DismissCircleIcon />}
      </TableCell>
      <TableCell>
        {item.isActive ? <CheckmarkCircleIcon /> : <DismissCircleIcon />}
      </TableCell>
      <TableCell>
        {item.dateCreated ? utcToLocalDateString(setting, item.dateCreated) : ""}
      </TableCell>
      {/* <TableCell role="gridcell" tabIndex={0}>
                    <Popover {...props} positioning="below-start">
                        <PopoverTrigger disableButtonEnhancement>
                            <TableCellLayout media={<MeatBallsMenuIcon />} onClick={() => handleModal(item)} />
                        </PopoverTrigger>
                        <PopoverSurface tabIndex={-1} className="listingPopoverWrapper">
                            {menu}
                        </PopoverSurface>
                    </Popover>
                </TableCell> */}
    </TableRow>
  ));
};

export default AllocatedRsrcRow;
